module.exports = __webpack_public_path__ + "30ba5bc893d9c0d486a80bedcd45d1da.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/drums/12_B2.mp3
// module id = 52
// module chunks = 0